'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_react-slick@0.17.1@react-slick/lib/index.js
// module id = 282
// module chunks = 0 1